import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {resetAllReferralInfo} from '/redux/action/candidate.action';
import {
  AllReferralReduxKeys,
  resetReferralReport,
} from '/redux/action/report.action';

import {AllReferralsReport} from './AllReferralsReport';

export default connect(
  createStructuredSelector({}),

  dispatch => ({
    resetReferralReport: ({reportKey}) =>
      dispatch(resetReferralReport({reportKey, data: null})),
    resetAllReferralInfo: () => dispatch(resetAllReferralInfo()),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      resetReferralReportData: () => {
        dispatchProps.resetAllReferralInfo();
        AllReferralReduxKeys.forEach(element => {
          dispatchProps.resetReferralReport({
            reportKey: element,
          });
        });
      },
    };
  },
)(AllReferralsReport);
